import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    response: undefined,
    error: undefined,
};

export const RemoveMediaSlice = createSlice({
    name: "removeMedia",
    initialState,
    reducers: {
        removeMediaRequest(state) {
            state.loading = true;
        },
        removeMediaRequestSuccess(state, action) {
            state.loading = false;
            state.response = action.payload;
            state.error = undefined;
        },
        removeMediaRequestError(state, action) {
            state.loading = false;
            state.error = action.payload;
            state.response = undefined;
        },
        removeMediaStateReset(state) {
            state.loading = false;
            state.error = undefined;
            state.response = undefined;
        },
    },
});

export const {
    removeMediaRequest,
    removeMediaRequestSuccess,
    removeMediaRequestError,
    removeMediaStateReset,
} = RemoveMediaSlice.actions;

export default RemoveMediaSlice.reducer;
